
<template>
  <div class="record_box">
    <div class="box">
      <div class="line"></div>
      <div class="content"
           v-html="content"></div>
      <div class="bg"></div>
    </div>
    <p class="btn"
       :class="{'hasAuth':hasAuth}"
       @click="updateStatus">{{btnText}}</p>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      hasAuth: 0,//0：未认证，1：授权成功，2：授权失败
      btnText: '我已阅读并确认授权',
      content: '',
      productId: '',
      str: `  我们一向庄严承诺保护使用户的隐私。您在使用我们服务时，我们可能会收集和使用您的相关信息。
本《隐私政策》适用于我们提供的一切我们服务。当您使用我们任何单项服务时，您同意接受本《隐私政策》以及我们在该单项服务中发出的特定隐私信息类政策条款（下列称“特定条款”）的保护，在此情况下特定条款与本政策条款同时对您产生效力。例如：使用我们在线游戏服务的用户，同时适用本《隐私政策》以及《网络游戏用户隐私权保护和个人信息利用政策》（见附件一）；又如，使用我们支付的用户，同时适用本《隐私政策》以及《我们支付隐私政策》（见附件二）。如特定条款与本《隐私政策》条款存在同类条款的不一致约定，则在特定条款约束范围内应以特定条款为准。如我们提供的某一单项服务不适用本《隐私政策》的，该服务中会以适当方式明示排除适用本《隐私政策》。
请注意我们不时地会检查我们的政策，因此有关的措施会随之变化。我们恳请您定期光顾本页面，以确保对我们《隐私政策》最新版本始终保持了解。在阅读完本政策之后，如您对本《隐私政策》或与本《隐私政策》相关的事宜有任何问题，请与我们联系。
您使用或继续使用我们服务，都表示您同意我们按照本《隐私政策》收集、使用、储存和分享您的信息。
`
    }
  },
  mounted () {
    this.util.title('隐私协议');
    this.productId = this.$route.query.productId
    this.getStatus();
  },
  methods: {
    Trim (str) {  //str表示要转换的字符串  
      return str.replace(/\n|\r\n/g, "<br/>");
    },
    //查询是否授权状态
    getStatus () {//
      let _this = this;
      let param = {
        productId: this.productId
      }
      this.$get('/app/v1/product/baseinfo/getByCustomerId', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.content = e.data.content ? _this.Trim(e.data.content) : ''
            if (e.data.impowerStatus) {
              _this.hasAuth = e.data.impowerStatus.status
              _this.btnText = '已授权'
            }
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    // 去授权
    updateStatus () {
      let _this = this;
      if (_this.hasAuth == 1) {
        return false;
      }
      let param = {
        productId: this.productId,
        status: 1,
      }
      this.$post('/app/v1/product/baseinfo/insertPorductImpower', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.hasAuth = 1;
            _this.btnText = '已授权'
            _this.util.toast({ msg: '授权成功' })
            setTimeout(() => {
              _this.util.toClientPath(0)//返回客户端上一页；
            }, 1000)
          }
          else {
            _this.util.toast({ type: 'fail', msg: e.message })
          }
        })
        .catch(error => { });
    },
  },
  popBack () {

  }

}
</script>
<style scoped>
.record_box {
  background: #fff;
  width: 100%;
  /* height: 100%; */
  padding-bottom: 0.5rem;
}
.bg {
  height: 0.3rem;
  width: 100%;
}
.line {
  width: 100%;
  height: 0.1rem;
  background: #f7f7f7;
}
.content {
  padding: 0.13rem 0.19rem;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, PingFangSC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 28px;
}
.box {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0.5rem; /*距离底部的距离为底部盒子的高度，自己也可以设置*/
  overflow-y: scroll;
  width: 100%;
  -webkit-overflow-scrolling: touch; /*这句是为了滑动更顺畅*/
}
.btn {
  display: inline-block;
  width: 100%;
  margin: 0 auto;
  color: #fff;
  height: 0.5rem;
  text-align: center;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  line-height: 0.5rem;
  font-size: 0.17rem;
  position: absolute;
  bottom: 0;
  left: 0;
}
.hasAuth {
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  opacity: 0.4;
}
</style>
